export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./works.vue?vue&type=template&id=6a26d00b&"


//////////////////
// WEBPACK FOOTER
// ./src/views/works/works.vue?vue&type=template&id=6a26d00b&
// module id = null
// module chunks = 